export const downloadFile = (request: Promise<unknown>, fileName: string) =>
  request
    .then((response) => (response as Response).blob())
    .then((blob) => {
      const fileUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = fileUrl;
      link.target = "_blank";
      link.download = fileName;

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link?.parentNode?.removeChild(link);

      URL.revokeObjectURL(link.href);
    });
